import React from 'react'

const CardRow = ({ children }) => (
  <div className="my-12 mx-auto">
    <div className="flex flex-wrap">{children}</div>
  </div>
)

export default CardRow
